
import { Component, Prop, Vue, Model, Watch } from "vue-property-decorator";
import { v1 as uuid } from "uuid";
import PortalBaseField from "./PortalBaseField.vue";

@Component
export default class PortalNumberField extends PortalBaseField {
  @Prop() private labelClass!: string;
  @Prop() private label!: string;
  @Model("change", { type: Number }) readonly data!: number | null;
  @Prop() private md: string | number;
  @Prop() private lg: string | number;
  @Prop() private xl: string | number;
  @Prop() private readonly: string;
  @Prop() private tooltip: string;
  @Prop() private state: any;
  @Prop() private invalidFeedback: any;
  @Prop() private required: boolean;
  private show: boolean = false;
  localData: number | null = null;

  created() {
    this.localData = this.data;
  }

  @Watch('data')
  onDataChange(value: number | null) {
    this.localData = value;
  }

  @Watch('localData')
  onLocalDataChange(value: number | null) {
    this.$emit('change', this.toNumberOrNull(value));
  }

  private toNumberOrNull(value: any): number | null {
    if (value === null || value === undefined || value === '') return null;
    const n = typeof value === 'number' ? value : Number(value);
    return Number.isNaN(n) ? null : n;
  }
}
